import { useGraphQLMutation } from '@opengov/bnp-core';
import { graphql } from '../../../../../../gql-generated/hasura';
import { HASURA_SERVICE_URL } from '../../../../../../config/config';
import { customReportsQueryKeys } from '../../hooks/customReportsQueryKeys';

const UpdateSpreadsheetNameMutation = graphql(`
  mutation UpdateSpreadsheetName($id: uuid!, $name: String!) {
    update_spreadsheets_by_pk(pk_columns: { id: $id }, _set: { name: $name, updatedAt: "now()" }) {
      id
      name
    }
  }
`);

export function useUpdateSpreadsheetName() {
  return useGraphQLMutation({
    mutationKey: customReportsQueryKeys.updateSpreadsheet(),
    document: UpdateSpreadsheetNameMutation,
    url: HASURA_SERVICE_URL
  });
}
